module.exports = __webpack_public_path__ + "img/sds_1674-1.de4866f3.jpg";